import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import StepsComponent from './StepsComponent';
import ButtonComponent from './button/ButtonComponent';

import './HowItWorksComponent.scss';

class HowItWorksComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isOffline: this.props.isOffline, isEbon: this.props.isEbon };
    }

    handleOnClick = mode => {
        if (mode === 'ebon') {
            this.setState({
                isEbon: !this.state.isEbon,
                isOffline: false
            });
        } else if (mode === 'offline') {
            this.setState({
                isEbon: false,
                isOffline: !this.state.isOffline
            });
        } else {
            this.setState({
                isEbon: false,
                isOffline: false
            });
        }
    };

    render() {
        const { i18n, topShadow, showTitle, showButtons, cssClass, isEbon } = this.props;
        return (
            <section className={`cmt-ca-marche ${topShadow ? ' cmt-ca-marche-shadow' : ''}`}>
                <div className={cssClass}>
                    {showTitle && <h2>{isEbon ? i18n.TITLE_EBON : i18n.TITLE}</h2>}
                    {showButtons && (
                        <div className="buttonWrapper">
                            <ButtonComponent
                                color="main"
                                text={i18n.BOUTON_EBON}
                                cssClass={`styledButton ${this.state.isEbon ? 'disabled' : ''}`}
                                onClick={
                                    !this.state.isEbon ? () => this.handleOnClick('ebon') : null
                                }
                            />
                            <ButtonComponent
                                color="main"
                                text={i18n.BOUTON_ON}
                                cssClass={`styledButton ${
                                    !this.state.isOffline && !this.state.isEbon ? 'disabled' : ''
                                }`}
                                onClick={
                                    this.state.isOffline || this.state.isEbon
                                        ? () => this.handleOnClick('online')
                                        : null
                                }
                            />
                        </div>
                    )}
                    <StepsComponent
                        isOffline={showButtons ? this.state.isOffline : this.props.isOffline}
                        isEbon={showButtons ? this.state.isEbon : this.props.isEbon}
                        showAloOnly={this.props.showAloOnly}
                    />
                </div>
            </section>
        );
    }
}

HowItWorksComponent.propTypes = {
    showTitle: PropTypes.bool,
    showButtons: PropTypes.bool,
    isOffline: PropTypes.bool,
    showAloOnly: PropTypes.bool,
    isEbon: PropTypes.bool,
    topShadow: PropTypes.bool,
    cssClass: PropTypes.string,
    i18n: PropTypes.object.isRequired
};

const mapStoreToProps = state => ({
    i18n: state.i18n.feature.aide.HOW_IT_WORKS
});

export default connect(mapStoreToProps)(HowItWorksComponent);



// WEBPACK FOOTER //
// ./src/components/HowItWorksComponent.js